//import { default as utils } from '../../../src/assets/js/src/utils.js';
import { default as utils } from '../../assets/js/src/utils.js';

function init() {

	$(document).on('located', function(e, screenLocation) {

		/*
		var fullDepartmentName = (screenLocation.department.toLowerCase().indexOf('valkea') > -1)
									? screenLocation.department
									: 'Valkea ' + screenLocation.department;

		$('.page-header__info-location .department').text(fullDepartmentName);
		$('.page-header__info-location .floor').text(screenLocation.floor);
		$('.page-header__info-location .label').addClass('label--' + screenLocation.department.toLowerCase());

		$('.page-header__info-location').addClass('is-ready');
		*/

	});

	galaxoClock.init();

}

var galaxoClock = {
	init: function(getServerTime) {

		var now;
		var _this = this;
		var secondsUntilFullMin;
		var dfd = (getServerTime) ? utils.getServerDate() : $.when('');

		dfd.then(function(date) {

			now = date || new Date();
			secondsUntilFullMin = 60 - now.getSeconds();

			_this.setClock(now);

			$('.page-header__info-clock').addClass('is-ready');

			setTimeout(function() {

				now.setMinutes(now.getMinutes() + 1);
				_this.setClock(now);

				setInterval(function() {
					now.setMinutes(now.getMinutes() + 1);
					_this.setClock(now);
				}, 60000);

			}, secondsUntilFullMin * 1000);

		});
	},
	setClock: function setClock(date) {
		let hours = utils.leftpad(date.getHours(), 2, 0);
		let minutes = utils.leftpad(date.getMinutes(), 2, 0);
		$('.page-header__info-clock').text(`${hours}:${minutes}`);
	}
};


export default {
	init: init
};
